export default {"src":"/_next/static/media/client-04.8316bdf5.svg","height":36,"width":85,"blurWidth":0,"blurHeight":0};